import { render, staticRenderFns } from "./ItemPotential.vue?vue&type=template&id=4cdbce06&scoped=true&"
import script from "./ItemPotential.vue?vue&type=script&lang=js&"
export * from "./ItemPotential.vue?vue&type=script&lang=js&"
import style0 from "./ItemPotential.vue?vue&type=style&index=0&id=4cdbce06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbce06",
  null
  
)

export default component.exports